module.exports = __webpack_public_path__ + "img/logo.b6ac51c1.png";